export const RX_INT = /^\s*(([1-9]\d*)|0)\s*$/;
export const RX_FLOAT = /^\s*((([1-9]\d*)|0)(\.\d+)?)\s*$/;
export const RX_INCHES = /^\s*((([1-9]\d*)|0)(('|\s?ft)(\s(([1-9]\d*)|0)("|\s?in))?)?)\s*$/;
